import { FunctionComponent } from 'react';
import { designTokens, Stack, Typography } from '@monorepo/nova-ui';

interface Props {
  title: string;
  firstName: string;
  lastName: string;
  address: string;
  phoneNumber: string;
  email: string;
}

const BillClientDetails: FunctionComponent<Props> = ({
  title,
  firstName,
  lastName,
  address,
  phoneNumber,
  email,
}) => (
  <Stack>
    <Typography variant="body2">{title}</Typography>
    <Typography
      variant="body2"
      fontWeight={designTokens.typography.fontWeights.medium}
    >
      {firstName + ' ' + lastName}
    </Typography>
    <Typography
      variant="body2"
      fontWeight={designTokens.typography.fontWeights.medium}
    >
      {address}
    </Typography>
    <Typography
      variant="body2"
      fontWeight={designTokens.typography.fontWeights.medium}
    >
      {phoneNumber}
    </Typography>
    <Typography
      variant="body2"
      fontWeight={designTokens.typography.fontWeights.medium}
    >
      {email}
    </Typography>
  </Stack>
);

export default BillClientDetails;
